import { PayloadAction } from '@reduxjs/toolkit';

import { VariantsState } from 'editor/src/store/variants/types';

const setSelectedProductIdReducer = (state: VariantsState, action: PayloadAction<string | undefined>) => {
  state.selectedProductId = action.payload;
};

export default setSelectedProductIdReducer;
